import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { PenLine } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { downloadPdf } from './AnwesenheitTag';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const de = (iso) => (iso ? iso.split('-').reverse().join('.') : '');

export const EinwilligungEUnterschrift = ({ teilnehmerId }) => {
  const [status, setStatus] = useState(null);
  const laden = () => axios.get(`${API}/anwesenheit-tag/einwilligung/${teilnehmerId}`).then((r) => setStatus(r.data)).catch(() => setStatus(null));
  useEffect(() => { laden(); }, [teilnehmerId]); // eslint-disable-line react-hooks/exhaustive-deps

  const papier = async () => {
    const datum = window.prompt('Datum der unterschriebenen Papier-Einwilligung (TT.MM.JJJJ):');
    if (!datum) return;
    const quelle = window.prompt('Nachweis / Ablageort (z. B. Erstgespräch, Papier, Akte):');
    if (!quelle) return;
    try {
      await axios.post(`${API}/anwesenheit-tag/einwilligung-papier/${teilnehmerId}`, { datum, quelle });
      toast.success('Papier-Einwilligung erfasst');
      laden();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
  };
  const [sende, setSende] = useState(false);
  const elektronischSenden = async () => {
    setSende(true);
    try {
      const r = await axios.post(`${API}/sign-requests`, { teilnehmer_id: teilnehmerId, dokumente: ['einwilligung_e_unterschrift'], versand_methode: 'email' });
      toast.success(`Einwilligung zur Unterschrift an ${r.data.tn_email} gesendet`);
    } catch (e) { toast.error(e?.response?.data?.detail || 'Versand fehlgeschlagen'); }
    finally { setSende(false); }
  };
  const widerruf = async () => {
    if (!window.confirm('Widerruf der Einwilligung mit heutigem Datum erfassen? Ab heute wird keine Unterschrift mehr übertragen.')) return;
    try {
      await axios.post(`${API}/anwesenheit-tag/einwilligung-widerruf/${teilnehmerId}`);
      toast.success('Widerruf erfasst');
      laden();
    } catch (e) { toast.error(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
  };

  const ew = status?.einwilligung;
  return (
    <Card className="border-l-4 border-l-[#E2621B]" data-testid="card-einwilligung-e-unterschrift">
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <PenLine size={18} className="text-[#E2621B]" /> Einwilligung elektronische Unterschrift (Anwesenheitslisten)
        </CardTitle>
        <p className="text-xs text-stone-500 mt-1">
          Eigenes Formular. Wird im Unterschriften-Versand mit ausgewählt oder auf Papier unterschrieben und hier erfasst.
        </p>
      </CardHeader>
      <CardContent className="space-y-3">
        <div data-testid="einwilligung-status" className={`text-sm px-3 py-2 rounded-md border ${ew ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 'bg-stone-100 border-stone-300 text-stone-700'}`}>
          {ew ? `Erteilt am ${de(ew.datum)} – ${ew.quelle}` : 'Nicht erteilt – auf den Anwesenheitslisten wird keine Unterschrift übertragen.'}
          {status?.widerruf && <div className="text-xs mt-1">Widerruf erfasst am {de(status.widerruf.datum)} durch {status.widerruf.erfasst_von}</div>}
        </div>
        <div className="flex flex-wrap gap-2">
          <Button variant="outline" size="sm" data-testid="btn-einwilligung-pdf"
            onClick={() => downloadPdf(`/teilnehmer/${teilnehmerId}/einwilligung-e-unterschrift-pdf`, 'Einwilligung_eUnterschrift.pdf')}>
            Formular (PDF)
          </Button>
          <Button size="sm" className="bg-emerald-600 hover:bg-emerald-700 text-white" disabled={sende} data-testid="btn-einwilligung-senden" onClick={elektronischSenden}>
            {sende ? 'Sende…' : 'Zur Unterschrift per E-Mail senden'}
          </Button>
          <Button variant="outline" size="sm" data-testid="btn-papier-einwilligung" onClick={papier}>Papier-Einwilligung erfassen (bereits unterschrieben)</Button>
          {ew && <Button variant="outline" size="sm" data-testid="btn-einwilligung-widerruf" onClick={widerruf}>Widerruf erfassen</Button>}
        </div>
      </CardContent>
    </Card>
  );
};
